import { useEffect, useState } from "react";
import QuestionBox from "../QuestionBox/QuestionBox";
import Switch from "../Switch/Switch";
import CSS from "./styles.module.css";

const QuestionSets = ({ key, item, ind, isActive }) => {
	const [switcher, setSwitcher] = useState(true);

	useEffect(() => {
		if (isActive) {
			setSwitcher(true);
		} else if (isActive === false) {
			setSwitcher(false);
		}
	}, [isActive]);

	const handleSwitch = () => {
		if (switcher) {
			setSwitcher(false);
		} else {
			setSwitcher(true);
		}
	};

	return (
		<div key={key} className={CSS.Topic}>
			<div className={CSS.Heading}>
				<h2>{item.topic}</h2>
				<div
					className={`${CSS.Toggle} ${"HiddenContent2"}`}
					contentEditable={false}
					onClick={handleSwitch}
				>
					<label>
						<font>
							{isActive && switcher === false
								? "Show Answers"
								: isActive && switcher === true
								? "Hide Answers"
								: isActive === false && switcher === true
								? "Hide Answers"
								: "Show Answers"}
						</font>
					</label>
					<Switch
						id={`${ind}_answerSwitch`}
						checked={
							isActive && switcher === false
								? false
								: isActive && switcher === true
								? true
								: isActive === false && switcher === true
								? true
								: false
						}
					/>
				</div>
			</div>
			<div className={CSS.QContainer}>
				{item.questions.map((ques, i) => (
					<QuestionBox
						key={i}
						data={ques}
						index={i}
						id={`${item.topic.split(" ")[0]}_${ind}_${i}`}
						isActive={
							isActive && switcher === false
								? false
								: isActive && switcher === true
								? true
								: isActive === false && switcher === true
								? true
								: false
						}
					/>
				))}
			</div>
		</div>
	);
};

export default QuestionSets;
